import { useMutation } from "react-query"

import {
  ConfirmActionViaEmailCodeParams,
  confirmActionViaEmailCode,
} from "../util/backend_api/userConfirmActionViaEmailCode"

interface SuccessResponse {
  success: boolean
}

export const CONFIRM_ACTION_VIA_EMAIL_CODE_KEY = "confirm_action_via_email_code"

export default function useConfirmActionViaEmailCode({ onSuccess }) {
  const { mutate, mutateAsync, data, isLoading, isError, error } = useMutation<
    SuccessResponse,
    Error,
    ConfirmActionViaEmailCodeParams
  >((values) => confirmActionViaEmailCode(values), {
    onSuccess: (data) => onSuccess(data),
  })

  return {
    mutate,
    mutateAsync,
    data,
    isLoading,
    isError,
    error,
  }
}
